import React from 'react';
import { InfoTitle, InfoCol, InfoDiv } from './styles/InfoStyles';
import { FadKobling } from '../../../parts';

const RenderFadoelKobling = ({
  fadKobling,
}) => {
  if (fadKobling) {
    return (
      <InfoCol>
        <InfoDiv>
          <InfoTitle>Fadkobling:</InfoTitle>
          <FadKobling value={fadKobling} />
        </InfoDiv>
      </InfoCol>
    );
  }
  return (null);
};

// Export
export default RenderFadoelKobling;
